import PropTypes from 'prop-types';

import { AlertBox, Typography } from '@vartanainc/design-system';
import { ReactComponent as WarningBadgeIcon } from '../../assets/warning-bade-icon.svg';

function WarningAlertBox({ message }) {
  return (
    <div className="w-full">
      <AlertBox
        variant="alert-box"
        backgroundColor="warn"
        icon={<WarningBadgeIcon />}
        content={<Typography variant="paragraph10">{message}</Typography>}
      />
    </div>
  );
}

WarningAlertBox.propTypes = {
  message: PropTypes.string.isRequired,
};

export default WarningAlertBox;
